import {
  AUTH_TOKEN_KEY,
  GET_SHOPPING_CART_LIST,
  DELETE_SHOPPING_CART,
  POST_SHOPPING_CART_PRODUCT
} from '../constants/';

import axios from 'axios';
const API_BASE_URL = "https://jk24xo38q9.execute-api.ap-southeast-1.amazonaws.com/dev"
const fetch=(headers={})=>axios.create({
  baseURL:API_BASE_URL,
  headers
})

export const getShoppingCartList = () => ({
  type: GET_SHOPPING_CART_LIST,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  })
    .get("/carts")
    .then(res => {
    })
})

export const postShoppingCartProduct = (payload) => ({
  type: POST_SHOPPING_CART_PRODUCT,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY),
    'Content-Type': "application/json"
  }).post(`${API_BASE_URL}/carts`, payload)
    .then(res => {
      return res
    })
    .catch(e => e)
})

export const deleteShoppingCartList = (id) => ({
  type: DELETE_SHOPPING_CART,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  })
    .get("/carts{id}", { params: id })
    .then(res => res.data)
})